import { captureException } from './ErrorHelper.js'
import { isIgnoredFirebaseAuthError } from '../../../pure-js/libs/ErrorFilterHelper'

/**
 * Global unhandled promise rejection handler
 *
 * IMPORTANT: This is a LAST RESORT handler. Most errors should be caught by:
 * 1. React Error Boundaries (for component errors)
 * 2. try-catch blocks (for async operations)
 * 3. .catch() handlers (for promises)
 *
 * This handler should only catch truly unexpected errors from YOUR code.
 * External errors (browser extensions, third-party scripts) are filtered out.
 */
export default function onUnhandledPromiseRejection(error: any) {
  // Ignore expected Firebase auth errors
  if (isIgnoredFirebaseAuthError(error)) return

  // Ignore AbortError - usually from cancelled fetch requests (component unmount, navigation, etc.)
  if (error?.name === 'AbortError' || error?.message?.includes('aborted')) return

  // Convert non-Error objects to Error-like objects for better logging
  const errorObj =
    error instanceof Error ? error : new Error(error?.message || error?.toString() || 'Unhandled promise rejection')

  // Preserve original error properties
  if (error?.name) errorObj.name = error.name
  if (error?.stack) errorObj.stack = error.stack
  if (error?.code) (errorObj as any).code = error.code

  // captureException will filter out external errors (browser extensions, etc.)
  captureException(errorObj)
}
